export interface LoginInitialValue {
  email: string;
  password: string;
}

export const loginInitialValue = {
  email: "",
  password: "",
};
